var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.5L7 20.5C4.519 20.5 2.5 18.481 2.5 16L2.5 12C2.5 11.724 2.724 11.5 3 11.5C3.276 11.5 3.5 11.724 3.5 12L3.5 16C3.5 17.93 5.07 19.5 7 19.5L17 19.5C18.93 19.5 20.5 17.93 20.5 16L20.5 12C20.5 11.724 20.724 11.5 21 11.5C21.276 11.5 21.5 11.724 21.5 12L21.5 16C21.5 18.481 19.481 20.5 17 20.5ZM12.354 14.354L16.354 10.354C16.549 10.159 16.549 9.842 16.354 9.647C16.159 9.452 15.842 9.452 15.647 9.647L12.501 12.793L12.501 4C12.501 3.724 12.277 3.5 12.001 3.5C11.725 3.5 11.501 3.724 11.501 4L11.501 12.793L8.35501 9.647C8.16001 9.452 7.84301 9.452 7.64801 9.647C7.55001 9.745 7.50201 9.87301 7.50201 10.001C7.50201 10.129 7.55101 10.257 7.64801 10.355L11.648 14.355C11.842 14.549 12.158 14.549 12.354 14.354Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.5286af5b59354c90a68173609915b774.svg";
export { ForwardRef as ReactComponent };